// MAKA PARIS — Theme JS (The Row style)

// ── BURGER MENU ──
(function() {
  var btn = document.getElementById('burger');
  var menu = document.getElementById('mobileMenu');
  if (!btn || !menu) return;
  btn.addEventListener('click', function() {
    btn.classList.toggle('open');
    menu.classList.toggle('open');
    document.body.style.overflow = menu.classList.contains('open') ? 'hidden' : '';
  });
  menu.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      btn.classList.remove('open');
      menu.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
})();

// ── GALLERY SWITCH ──
// Backward compatible: setMainImg(src, el) OR setMainImg(src, zoomSrc, el)
function setMainImg(src, zoomSrc, el) {
  var main = document.getElementById('galleryMain');
  if (!main) return;
  // Handle old 2-arg call where 2nd param is the element
  if (zoomSrc && typeof zoomSrc !== 'string') {
    el = zoomSrc;
    zoomSrc = null;
  }
  main.style.opacity = '0';
  setTimeout(function() {
    main.src = src;
    main.removeAttribute('srcset');
    if (zoomSrc) main.setAttribute('data-zoom', zoomSrc);
    main.style.opacity = '1';
  }, 150);
  document.querySelectorAll('.gallery-thumb').forEach(function(t) {
    t.classList.remove('active');
  });
  if (el) el.closest('.gallery-thumb').classList.add('active');
}

// ── IMAGE ZOOM (full screen overlay) ──
function openZoom(imgEl) {
  var overlay = document.getElementById('zoomOverlay');
  var zoomImg = document.getElementById('zoomImg');
  if (!overlay || !zoomImg || !imgEl) return;
  var src = imgEl.getAttribute('data-zoom') || imgEl.currentSrc || imgEl.src;
  zoomImg.src = src;
  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}
function closeZoom() {
  var overlay = document.getElementById('zoomOverlay');
  if (!overlay) return;
  overlay.style.display = 'none';
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeZoom();
});

// ── SIZE SELECTOR ──
(function() {
  document.querySelectorAll('.pd-size').forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Si taille indisponible → ouvrir la modale "Me prévenir"
      if (btn.classList.contains('unavailable')) {
        var color = btn.dataset.color || '';
        var size = btn.dataset.size || '';
        openNotify(color, size);
        return;
      }
      // Sinon : sélection normale
      document.querySelectorAll('.pd-size').forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      var addBtn = document.getElementById('addToCart');
      if (addBtn) addBtn.dataset.variantId = btn.dataset.variantId;
    });
  });
})();

// ── NOTIFY MODAL : me prévenir quand disponible ──
function openNotify(color, size) {
  var modal = document.getElementById('notifyModal');
  if (!modal) return;
  var productTitle = (document.querySelector('.pd-name') || {}).textContent || '';
  productTitle = productTitle.trim();
  // Pré-remplir les champs cachés
  var colorField = document.getElementById('notifyColor');
  var sizeField = document.getElementById('notifySize');
  var bodyField = document.getElementById('notifyBody');
  var contextField = document.getElementById('notifyContext');
  if (colorField) colorField.value = color || '';
  if (sizeField) sizeField.value = size || '';
  // Texte de contexte affiché à l'utilisateur
  var ctx = productTitle;
  if (color) ctx += ' — ' + color;
  if (size) ctx += ' — Taille ' + size;
  if (contextField) contextField.textContent = ctx;
  // Corps du mail envoyé à Makka
  var body = 'Bonjour, merci de me prévenir lorsque ' + productTitle;
  if (color) body += ' en ' + color;
  if (size) body += ' (taille ' + size + ')';
  body += ' sera à nouveau disponible.';
  if (bodyField) bodyField.value = body;
  // Reset l'état si l'utilisateur réouvre après un succès
  var content = document.getElementById('notifyContent');
  var success = document.getElementById('notifySuccess');
  if (content) content.style.display = '';
  if (success) success.style.display = 'none';
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
  setTimeout(function() {
    var emailField = document.getElementById('notifyEmail');
    if (emailField) emailField.focus();
  }, 100);
}

function closeNotify() {
  var modal = document.getElementById('notifyModal');
  if (!modal) return;
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

// Fermer la modale au clic en dehors ou via Échap
(function() {
  var modal = document.getElementById('notifyModal');
  if (!modal) return;
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeNotify();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeNotify();
  });
  // Intercepter la soumission du formulaire pour afficher un état de succès dans la modale
  var form = document.getElementById('notifyForm');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/contact#contact_form', {
        method: 'POST',
        body: data,
        credentials: 'same-origin'
      }).then(function() {
        document.getElementById('notifyContent').style.display = 'none';
        document.getElementById('notifySuccess').style.display = '';
      }).catch(function() {
        alert("Une erreur est survenue, merci de réessayer ou de nous écrire directement à contact@makaparis.com");
      });
    });
  }
})();

// ── COLOR SELECTOR + GALLERY FILTER ──
(function() {
  var colorBtns = document.querySelectorAll('.pd-color-btn');
  if (!colorBtns.length) return;

  function filterGalleryByColor(color) {
    if (!color) return;
    var colorLC = color.toLowerCase();
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var firstMatch = null;
    thumbs.forEach(function(thumb) {
      var alt = (thumb.dataset.alt || '').toLowerCase();
      // If alt-text contains the color, show. If no alt at all, show as fallback.
      var match = !alt || alt.indexOf(colorLC) !== -1;
      thumb.style.display = match ? '' : 'none';
      if (match && !firstMatch) firstMatch = thumb;
    });
    if (firstMatch && typeof setMainImg === 'function') {
      setMainImg(firstMatch.dataset.imgSrc, firstMatch.dataset.imgZoom, firstMatch);
    }
  }

  function filterSizesByColor(color) {
    if (!color) {
      document.querySelectorAll('.pd-size').forEach(function(b) { b.style.display = ''; });
      return;
    }
    document.querySelectorAll('.pd-size').forEach(function(btn) {
      btn.style.display = (btn.dataset.color === color) ? '' : 'none';
    });
    // Reset selected size + clear add-to-cart variant
    document.querySelectorAll('.pd-size').forEach(function(b) { b.classList.remove('selected'); });
    var addBtn = document.getElementById('addToCart');
    if (addBtn) delete addBtn.dataset.variantId;
  }

  colorBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      colorBtns.forEach(function(b) { b.classList.remove('selected'); });
      btn.classList.add('selected');
      var color = btn.dataset.color;
      filterGalleryByColor(color);
      filterSizesByColor(color);
    });
  });

  // Initialize on load — apply first selected color
  var initial = document.querySelector('.pd-color-btn.selected');
  if (initial) {
    filterGalleryByColor(initial.dataset.color);
    filterSizesByColor(initial.dataset.color);
  }
})();

// ── ADD TO CART ──
(function() {
  var btn = document.getElementById('addToCart');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var id = btn.dataset.variantId;
    if (!id) { alert('Veuillez sélectionner une taille.'); return; }
    var txt = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function() {
      window.location.href = '/cart';
    }).catch(function() {
      btn.textContent = txt;
      btn.disabled = false;
    });
  });
})();

// ── NAV HIDE ON SCROLL ──
(function() {
  var nav = document.querySelector('nav');
  if (!nav) return;
  var last = 0;
  window.addEventListener('scroll', function() {
    var y = window.scrollY;
    nav.style.transform = (y > 80 && y > last) ? 'translateY(-100%)' : 'translateY(0)';
    nav.style.transition = 'transform .3s ease';
    last = y;
  }, { passive: true });
})();
